import { render, staticRenderFns } from "./MonacoEditor.vue?vue&type=template&id=5f03c267&scoped=true"
import script from "./MonacoEditor.vue?vue&type=script&lang=js"
export * from "./MonacoEditor.vue?vue&type=script&lang=js"
import style0 from "./MonacoEditor.vue?vue&type=style&index=0&id=5f03c267&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f03c267",
  null
  
)

export default component.exports